import { Modal } from 'antd';
import React from 'react';
import {Button} from 'components/Button';
import confirmModalPic from '../../../Assets/userManagementV3/confirmModalPic.png'
import { CloseOutlined } from "@ant-design/icons";
import './confirmLeaveEdit.css';

const ConfirmLeaveEdit = ({ onClose, visible, onDelete, deleteLoader, message, noColor }) => {
    return (
        <Modal
            open={visible}
            footer={false}
            onCancel={onClose}
            centered
            width={460}
            className="modal-round-corner confirm-save-modal"
            closeIcon={<CloseOutlined style={{fontSize: 20,color: "#AEAEAE",fontWeight: 600, paddingTop: 20, paddingRight: 10 }}/>}
        >
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 20 }}>
                <img src={confirmModalPic} alt="" style={{ width: 120, height: 120 }} />
            </div>
            <div className='r-c-c m-t-20'>
                <div style={{ fontFamily: 'Roboto, sans-serif', fontSize: 24, fontWeight: 500, color: '#191919' }}>Confirm</div>
            </div>
            <div className='r-c-c m-t-10'>
                <div style={{ fontFamily: 'Roboto, sans-serif', fontSize: 16, color: "#636363", textAlign: 'center' }}>
                    {message || "Are you sure you want to save the changes?"}
                </div>
            </div>
            <div className='r-c-c m-t-50'>
                <Button
                    onClick={onClose}
                    style={{
                        width: 178,
                        height: 45,
                        borderRadius: 12,
                        backgroundColor: '#FFFFFF',
                        border: '2px solid #AEAEAE',
                        color: noColor || '#AEAEAE',
                        fontFamily: 'Roboto, sans-serif',
                        fontWeight: 700,
                        fontSize: 16,
                    }}
                >
                    NO
                </Button>
                <Button
                    type="primary"
                    onClick={() => onDelete()}
                    loading={deleteLoader}
                    style={{
                        width: 178,
                        height: 45,
                        borderRadius: 12,
                        backgroundColor: '#594099',
                        border: 'none',
                        color: '#FFFFFF',
                        marginLeft: 25,
                        fontFamily: 'Roboto, sans-serif',
                        fontWeight: 700,
                        fontSize: 16,
                    }}
                >
                    YES
                </Button>
            </div>
        </Modal>
    );
};

export default ConfirmLeaveEdit;